import { useEffect, useRef } from 'react'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { closeWebsocket } from '../../net'
import { DetailBoard } from './DetailBoard'
import { GenerateBoard } from './GenerateBoard'
import style from './result.module.css'
import {
	taskInitAtom,
	taskDetailAtom,
	chatHistoryAtom,
	promptAtom,
	stopChatAtom,
	meshProfileAtom,
	chatTextAtom,
	chatDialogStartAtom,
	generateStageAtom,
} from './store.js'
import { exportToImage } from "./utils";
import { logInfoAtom } from '../Header/store'

function ResultBoard() {
	const taskDetail = useRecoilValue(taskDetailAtom)
	const [chatHistory, setChatHistory] = useRecoilState(chatHistoryAtom)
	const setMeshProfile = useSetRecoilState(meshProfileAtom)
	const [prompt, setPrompt] = useRecoilState(promptAtom)
	const [stopChat, ] = useRecoilState(stopChatAtom)
	const chatHistoryRef = useRef({})
	const promptRef = useRef('')
	const [, setGenerateStage] = useRecoilState(generateStageAtom)
	const [logInfo, ] = useRecoilState(logInfoAtom)


	useEffect(() => {
		chatHistoryRef.current = { ...chatHistory }
	}, [chatHistory])

	useEffect(() => {
		promptRef.current = prompt
	}, [prompt])

	useEffect(() => {
		if (stopChat) {
			closeWebsocket()
		}
	}, [stopChat])


	useEffect(() => {
        if (!taskDetail) return
		setChatHistory(
			taskDetail.chat_history.reduce(
				(res, cur) => ({
					...res,
					[cur.chat_uuid]: { ...cur, timeStamp: new Date(cur.time).getTime() },
				}),
				{}
			)
		)
		setPrompt(taskDetail.prompt)
		setMeshProfile({...taskDetail.resources, task_uuid: taskDetail.task_uuid})
		setGenerateStage('detail')
		// eslint-disable-next-line
	}, [taskDetail])

	const dialogRef = useRef(null);

	const exportDialog = async () => {
	  await exportToImage(dialogRef.current, "dialog");
	};
  
	window.exportDialog = exportDialog;	

	return (
		<div className={style.con}>
			<div
				className={style.board}
				onPointerDown={(ev) => ev.stopPropagation()}
				ref={dialogRef}
			>
				{ logInfo ? (
						<>
							<GenerateBoard />
							<DetailBoard />
						</>
					) : 
					<p>
						Loading...
					</p> 
				}
			</div>
		</div>
	)
}

export { 
	ResultBoard, 
	GenerateBoard, 
	DetailBoard, 
	taskInitAtom, 
	taskDetailAtom, 
	chatTextAtom, 
	chatDialogStartAtom,
	generateStageAtom,
	promptAtom
}
